import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';

import { ComponentsService } from '../../services/components.service';
import { AttributeDataService } from '../../services/attribute-data.service';
import { ComponentUtilsService } from '../services/component-utils.service';
import { RssFeedValidationService } from '../services/rss-feed-validation.service';

@Component({
  selector: 'template-component-rss',
  templateUrl: './rss.component.html',
  styleUrls: ['./rss.component.scss'],
  standalone: false,
})
export class RssComponent {
  spinner = false;
  componentId;
  maxItems;
  feedUrl;
  validationResult;

  /** URL/parse failures — red input border and exclamation icon. */
  get hasUrlError(): boolean {
    return (
      !!this.validationResult &&
      this.validationResult !== 'VALID' &&
      this.validationResult !== 'INVALID_FEED'
    );
  }

  /** Valid URL (including W3C feed warnings) — green checkmark. */
  get hasValidUrl(): boolean {
    return (
      !!this.feedUrl?.trim() &&
      (this.validationResult === 'VALID' ||
        this.validationResult === 'INVALID_FEED')
    );
  }

  /** W3C feed validator reported errors while the URL itself is valid. */
  get hasW3cValidationErrors(): boolean {
    return this.validationResult === 'INVALID_FEED';
  }

  /** Direct link to the W3C feed validator for the current feed URL. */
  get w3cValidationUrl(): string {
    const feed = !this.feedUrl ? '' : this.feedUrl.trim();
    return `${RssFeedValidationService.VALIDATOR_URL}${encodeURIComponent(feed)}`;
  }

  constructor(
    private elementRef: ElementRef,
    private componentsFactory: ComponentsService,
    private attributeDataFactory: AttributeDataService,
    private componentUtils: ComponentUtilsService,
    private rssFeedValidation: RssFeedValidationService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    componentsFactory.registerDirective({
      type: 'rise-data-rss',
      element: this.elementRef.nativeElement,
      show: () => {
        this.componentId = this.componentsFactory.selected.id;
        this._load();
        this.saveFeed(); // validate Feed URL
      },
    });
  }

  saveFeed() {
    if (this._validateFeedUrl()) {
      this._isFeedParsable();
    }
    this.changeDetectorRef.detectChanges();
  }

  saveMaxItems() {
    this.attributeDataFactory.setAttributeData(
      this.componentId,
      'maxitems',
      parseInt(this.maxItems, 10),
    );
  }

  _load() {
    var maxItems = this.attributeDataFactory.getAvailableAttributeData(
      this.componentId,
      'maxitems',
    );

    this.feedUrl = this.attributeDataFactory.getAvailableAttributeData(
      this.componentId,
      'feedurl',
    );
    this.maxItems = maxItems ? maxItems.toString() : '1';
  }

  _validateFeedUrl() {
    //clear the error
    this.validationResult = '';

    var _feed = !this.feedUrl ? '' : this.feedUrl.trim();
    if (_feed === '') {
      //empty string is allowed
      return true;
    }

    //check if feed url is valid format
    if (this.componentUtils.isValidUrl(_feed)) {
      return true;
    }

    this.validationResult = 'INVALID_URL';
    return false;
  }

  _isFeedParsable() {
    this.spinner = true;

    return this.rssFeedValidation
      .isParsable(this.feedUrl)
      .then((result) => {
        if (result === 'VALID') {
          this.attributeDataFactory.setAttributeData(
            this.componentId,
            'feedurl',
            this.feedUrl,
          );

          return this._isFeedValid();
        }
        this.validationResult = result;
      })
      .finally(() => {
        this.spinner = false;
      });
  }

  _isFeedValid() {
    return this.rssFeedValidation.isValid(this.feedUrl).then((result) => {
      this.validationResult = result;
    });
  }
}
